var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "literary_info_wrap"
  }, [_c('div', {
    staticClass: "literary_info_thumbnail"
  }, [_c('img', {
    attrs: {
      "src": _vm.bookInfo.imagePath,
      "alt": _vm.bookInfo.title
    }
  })]), _c('div', {
    staticClass: "literary_info_content"
  }, [_c('strong', {
    staticClass: "literary_info_title"
  }, [_c('em', {
    staticClass: "blind"
  }, [_vm._v("작품 제목 : ")]), _vm._v(_vm._s(_vm.bookInfo.title) + " ")]), _c('span', {
    staticClass: "literary_info_author"
  }, [_c('em', {
    staticClass: "blind"
  }, [_vm._v("분야 / 저자: ")]), _vm._v(_vm._s(_vm.categoryName) + " / " + _vm._s(_vm.bookInfo.authorName))])]), _c('div', {
    staticClass: "literary_info_share"
  }, [_c('a', {
    staticClass: "btn_share",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickHandler.apply(null, arguments);
      }
    }
  }, [_vm._m(0)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "btn_text"
  }, [_c('em', {
    staticClass: "blind"
  }, [_vm._v("현재 페이지 ")]), _vm._v("공유하기")]);
}]

export { render, staticRenderFns }